export default "__VITE_ASSET__DV84bENC__"